import http from '../../../services/http-common';

class AgentAccountsService {
getAgentAccountsForList(id) {
    return http.get(`/AgentAccounts/list/${id}`);
    }
generateCode(id) {
    return http.get(`/AgentAccounts/tp/${id}`);
    }



getAgentAccountsIDforFirst(id) {
    return http.get(`/AgentAccounts/first/AgentAccountsID/${id}`);
}
getAgentAccountsIDOtherEntry(id) {
    return http.get(`/AgentAccounts/otherEntry/AgentAccountsID/${id}`);
}
insert(data) {
    return http.post(`/AgentAccounts/add`,data);
}
update(data) {
    return http.put(`/AgentAccounts/edit`,data);
}
}

export default new AgentAccountsService();